
export function nameSort(a_first, a_last, b_first, b_last) {
  const a_name = (a_first) ? `${a_last}, ${a_first}` : a_last;
  const b_name = (b_first) ? `${b_last}, ${b_first}` : b_last;
  if (!a_name) return 1;
  if (!b_name) return -1;
  return a_name.localeCompare(b_name, 'en', {'sensitivity': 'base'});
}

export function boolSort(a, b) {
  if ( a && !b) return -1;
  if (!a &&  b) return 1;
  return 0;
}

// Case-insensitive string comparison
export function stringSort(a, b) {
   if (!a && !b) return 0;
   if (!a) return -1;
   if (!b) return 1;
   return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

export function numericSort(a, b) {
  if (a > b) return -1;
  if (a < b) return 1;
  return 0;
}

